import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Breadcrumb } from "antd";
import * as actions from './redux/actions';

export class ExamHead extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  scrollToAnchor = (anchorName) => {
    if (anchorName) {
      let anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        anchorElement.scrollIntoView();
      }
    }
  }
  onCheck(index) {
    this.scrollToAnchor(`questionTypeIndex${index}`);
    this.props.actions.updateQuesTypeIndex({ payload: index });
  }
  render() {
    const { fetchGetExamDetailSuccess, totalQues, totalScore, QuestionTypeIndex } = this.props.quesStore;
    if (!fetchGetExamDetailSuccess) return null;
    let Data = fetchGetExamDetailSuccess;
    let { PaperInfo } = Data;
    return (
      <div className="ques-store-exam-head">
        <h1>
          <Breadcrumb separator=">">
            <Breadcrumb.Item href="/center/startExer/0">开始做题</Breadcrumb.Item>
            <Breadcrumb.Item href={PaperInfo.ExamPaperType === 0 ? "/center/startExer/2" : "/center/startExer/1"}>{PaperInfo.ExamPaperType === 0 ? "模拟试卷" : "历年真题"}</Breadcrumb.Item>
            <Breadcrumb.Item>{PaperInfo.Title}</Breadcrumb.Item>
          </Breadcrumb>
        </h1>
        <h2>
          {PaperInfo.Title}
        </h2>
        <h3>
          本卷共有{totalQues}题，作答时间为{PaperInfo.Time}分钟，总分{totalScore}分，{PaperInfo.PassScore}分及格。
            </h3>
        <h4>
          本套试卷含有主观题,针对主观题请自行参考解析自评。
            </h4>
        <div className="ques-checkbox">
          <ul>
            {
              Data.QuestionType.length > 0 &&
              Data.QuestionType.map((item, index) => (
                <li key={index} className={QuestionTypeIndex === index ? "check-item-active" : "check-item"} onClick={() => this.onCheck(index)}>{item.TypeInfo.QuestionType_Name}</li>
              ))
            }
          </ul>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExamHead);



// WEBPACK FOOTER //
// ./src/features/ques-store/ExamHead.js